import React from "react";
import styled from "styled-components";
import TimedButton from "../../components/atoms/TimedButton/TimedButton";
import TimedModal from "../../components/molecules/TimedModal/TimedModal";

interface ModalConfirmationCtrlProps{
    className?:string,
    text:string;
    callBackConfirm:Function;
    Close:Function;
    isPending?:boolean;
}

const ModalConfirmationCtrl = ({className, text, callBackConfirm, ...props}:ModalConfirmationCtrlProps)=>{
    const handleCancel = ()=>{
        props.Close();
    }
    const handleClickConfirm = ()=>{
        callBackConfirm();
    }
    return (
        <TimedModal
            size={"regular"}
            Close={props.Close}
            title={"Confirmation"}
            position={"center"}
            topPosition={"Middle"}
        >
            <div className={"wrap-confirmation" + className}>
                <div className={"TextConfirm"}>{text}</div>
                <div className={"wrap-actions"}>
                    <div className={"wrap-btn"}>
                        <TimedButton
                            size={"sm"}
                            themeColor={"Warning"}
                            text={"Je confirme"}
                            onClick={handleClickConfirm}
                            disabled={props.isPending}
                            isPending={props.isPending}
                        />
                    </div>
                    <div className={"wrap-btn"}>
                        <TimedButton
                            size={"sm"}
                            text={"Annuler"}
                            onClick={handleCancel}
                        />
                    </div>
                </div>
            </div>
        </TimedModal>
    )
}

const ModalConfirmation = styled(ModalConfirmationCtrl)`
    padding: 1rem;
    .TextConfirm{
      text-align: center;
      font-size: 18px;
    }
  .wrap-actions{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    .wrap-btn{
      padding: 0.5rem;
    }
  }
`
export default ModalConfirmation;